import Constantes from "./Constantes";

class Validacao {
    valida(objetoOuLista, chaves, nomes = "") {
        let objetos = Array.isArray(objetoOuLista) ? objetoOuLista : [objetoOuLista];
        let mensagens = "";
        let count = 1;

        objetos.forEach((objeto) => {
            console.log(objeto);
            chaves.forEach((chave, index) => {
                const valor = objeto[chave];

                // Verifica se o valor é null, undefined, vazio, array vazio ou objeto vazio
                const ehVazio = valor === null || valor === undefined || valor === "" ||
                                (Array.isArray(valor) && valor.length === 0) ||
                                (typeof valor === 'object' && !Array.isArray(valor) && Object.keys(valor).length === 0);

                if (ehVazio) {
                    if (nomes) {
                        mensagens = (Constantes.msg_campos_obrigatorios + nomes[index] + "(Item " + count + ")");
                    } else {
                        mensagens = (Constantes.msg_campos_obrigatorios + chave + "(Item " + count + ")");
                    }
                }
            });
            count++;
        });

        return mensagens ? mensagens : "";
    }
}

export default Validacao;
